// extracted by mini-css-extract-plugin
module.exports =  {"wipe":"CNDSH5_","wipe-loading":"B590Nrl","wipeLoading":"B590Nrl"};